// 权限配置
import Cookies from 'js-cookie'
import {fnCookie,fnRmCookie} from './localStorage'

const TokenKey = 'Token'
const UserInfo = 'User-Info'
const EnterTokenKey = 'EnterToken'
const EnterInfo = 'Enter-Info'
const EnterStatus = 'Enter-status'
const ActiveIndex = 'ActiveIndex'
const EqptInfo = 'EqptInfo'

// 项目端token操作
export function getActiveIndex() {
  return Cookies.get(ActiveIndex)
}
export function setActiveIndex(token) {
  return Cookies.set(ActiveIndex, token)
}
export function removeActiveIndex() {
  return Cookies.remove(ActiveIndex)
}

// 项目端token操作
export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: 1 / 3 // 超时时间,单位(天)
  })
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 企业端token操作
export function getEnterToken(){
	return Cookies.get(EnterTokenKey)
}
export function setEnterToken(token){
	return Cookies.set(EnterTokenKey,token,{
		expires:1 /3 // 超时时间,单位(天)
	})
}
export function removeEnterToken(){
	return Cookies.remove(EnterTokenKey)
}

// 项目端用户信息
export function getUserInfo() {
  return fnCookie(UserInfo)
}
export function setUserInfo(data) {
  return fnCookie(UserInfo, data)
}
export function removeUserInfo() {
  return fnCookie(UserInfo, '')
}

// 企业端用户信息
export function getEnterInfo(){
	return fnCookie(EnterInfo)
}
export function setEnterInfo(data){
	return fnCookie(EnterInfo,data)
}
export function removeEnterInfo(){
	return fnCookie(EnterInfo, '')
}

// 企业端是否登录
export function getEnterStatus(){
	return fnCookie(EnterStatus)
}
export function setEnterStatus(data){
	return fnCookie(EnterStatus,data)
}
export function removeEnterStatus(){
	return fnCookie(EnterStatus, '')
}

// 设置首页设备跳转页面 记录的设备号
export function getEqptInfo(){
    return fnCookie(EqptInfo)
}
export function setEqptInfo(data){
	return fnCookie(EqptInfo,data)
}
export function removeEqptInfo(){
	return fnCookie(EqptInfo, '')
}

// 设置单页权限
export function setPageAuth(_rotueName) {
  let _auth = fnCookie(ThreeAuth)
  return _auth[_rotueName]
}



// WEBPACK FOOTER //
// ./src/utils/auth.js